import Head from 'next/head';
import React from 'react';
import Meta from '../../components/Meta';

const Tarms = () => {
	return (
		<div>
			<Meta title="Tarms || Xhibiter | NFT Marketplace Next.js Template" />
			<div className="pt-[5.5rem] lg:pt-24">
				{/* <!-- TOS --> */}
				<section className="dark:bg-jacarta-800 relative py-16 md:py-24">
					<picture className="pointer-events-none absolute inset-0 -z-10 dark:hidden">
						<img src="/images/gradient_light.jpg" alt="gradient" className="h-full w-full" />
					</picture>
					<div className="container">
						<h1 className="font-display text-jacarta-700 text-center text-4xl font-medium dark:text-white">
							Terms Of Service
						</h1>
						<div className="article-content mx-auto max-w-[48.125rem]">
							<h2 className="text-base">Introduction</h2>
							<p>
								{
									"These Terms of Service (“Terms”) govern your access to and use of the Xhibiter website(s), our APIs, mobile app (the “App”), and any other software, tools, features, or functionalities provided on or in connection with our services; including without limitation using our services to view, explore, and create NFTs and use our tools, at your own discretion, to connect directly with others to purchase, sell, or transfer NFTs on public blockchains (collectively, the “Service”). “NFT” in these Terms means a non-fungible token or similar digital item implemented on a blockchain (such as the Ethereum blockchain), which uses smart contracts to link to or otherwise be associated with certain content or data. For purposes of these Terms, “user”, “you”, and “your” means you as the user of the Service. If you use the Service on behalf of a company or other entity then “you” includes you and that entity, and you represent and warrant that (a) you are an authorized representative of the entity with the authority to bind the entity to these Terms, and (b) you agree to these Terms on the entity's behalf."
								}
							</p>
							<p>
								PLEASE READ THESE TERMS OF SERVICE CAREFULLY AS THEY CONTAIN IMPORTANT INFORMATION
								AND AFFECT YOUR LEGAL RIGHTS. AS OUTLINED IN SECTION 16 BELOW, THEY INCLUDE A
								MANDATORY ARBITRATION AGREEMENT AND className ACTION WAIVER WHICH (WITH LIMITED
								EXCEPTIONS) REQUIRE ANY DISPUTES BETWEEN US TO BE RESOLVED THROUGH INDIVIDUAL
								ARBITRATION RATHER THAN BY A JUDGE OR JURY IN COURT.
							</p>
							<p>
								BY CLICKING TO ACCEPT AND/OR USING OUR SERVICE, YOU AGREE TO BE BOUND BY THESE TERMS
								AND ALL OF THE TERMS INCORPORATED HEREIN BY REFERENCE. IF YOU DO NOT AGREE TO THESE
								TERMS, YOU MAY NOT ACCESS OR USE THE SERVICE.
							</p>

							<p>
								Xhibiter is not a wallet provider, exchange, broker, financial institution, or
								creditor. Xhibiter provides a peer-to-peer web3 service that helps users discover
								and directly interact with each other and NFTs available on public blockchains. We
								do not have custody or control over the NFTs or blockchains you are interacting with
								and we do not execute or effectuate purchases, transfers, or sales of NFTs. To use
								our Service, you must use a third-party wallet which allows you to engage in
								transactions on blockchains.
							</p>

							<p>
								Because we have a growing number of services, we sometimes need to provide
								additional terms for specific services (and such services are deemed part of the
								“Service” hereunder and shall also be subject to these Terms). Those additional
								terms and conditions, which are available with the relevant service, then become
								part of your agreement with us if you use those services. In the event of a conflict
								between these Terms and any additional applicable terms we may provide for a
								specific service, such additional terms shall control for that specific service.
							</p>

							<h2>Ownership</h2>

							<p>
								The Service, including its “look and feel” (e.g., text, graphics, images, logos,
								page headers, button icons, and scripts), proprietary content, information and other
								materials, and all content and other materials contained therein, including, without
								limitation, the Xhibiter logo and all designs, text, graphics, pictures, data,
								software, sound files, other files, and the selection and arrangement thereof are
								the proprietary property of Xhibiter or our affiliates, licensors, or users, as
								applicable, and you agree not to take any action(s) inconsistent with such ownership
								interests. We and our affiliates, licensors, and users, as applicable, reserve all
								rights in connection with the Service and its content, including, without
								limitation, the exclusive right to create derivative works.
							</p>

							<h2>License to Access and Use Our Service and Content</h2>

							<p>
								You are hereby granted a limited, nonexclusive, nontransferable, nonsublicensable,
								and personal license to access and use the Service provided, however, that such
								license is subject to your compliance with these Terms. If any software, content, or
								other materials owned by, controlled by, or licensed to us are distributed or made
								available to you as part of your use of the Service, we hereby grant you a
								non-commercial, personal, non-assignable, non-sublicensable, non-transferrable, and
								non-exclusive right and license to access and display such software, content, and
								materials provided to you as part of the Service (and right to download a single
								copy of the App onto your applicable equipment or device), in each case for the sole
								purpose of enabling you to use the Service as permitted by these Terms, provided
								that your license in any content linked to or associated with any NFTs is solely as
								set forth by the applicable seller or creator of such NFT.
							</p>

							<h2>Intellectual Property Rights</h2>

							<p>
								You are solely responsible for your use of the Service and for any information you
								provide, including compliance with applicable laws, rules, and regulations, as well
								as these Terms, including the User Conduct requirements outlined above.
							</p>

							<p>
								By using the Service in conjunction with creating, submitting, posting, promoting,
								or displaying content, or by complying with {"OpenSea's"} metadata standards in your
								metadata API responses, you grant us a worldwide, non-exclusive, sublicensable,
								royalty-free license to use, copy, modify, and display any content, including but
								not limited to text, materials, images, files, communications, comments, feedback,
								suggestions, ideas, concepts, questions, data, or otherwise, that you submit or post
								on or through the Service for our current and future business purposes, including to
								provide, promote, and improve the Service. This includes any digital file, art, or
								other material linked to or associated with any NFTs that are displayed on the
								Service.
							</p>

							<h2>Miscellaneous</h2>

							<p>
								These Terms constitute the entire agreement between you and Xhibiter relating to
								your access to and use of the Service. These Terms, and any rights and licenses
								granted hereunder, may not be transferred or assigned by you without the prior
								written consent of Xhibiter, and Xhibiter’s failure to assert any right or provision
								under these Terms shall not constitute a waiver of such right or provision. No
								waiver by either party of any breach or default hereunder shall be deemed to be a
								waiver of any preceding or subsequent breach or default. The section headings used
								herein are for reference only and shall not be read to have any legal effect.
							</p>

							<p>
								The Service is operated by us in the United States. Those who choose to access the
								Service from locations outside the United States do so at their own initiative and
								are responsible for compliance with applicable local laws. You and Xhibiter agree
								that the United Nations Convention on Contracts for the International Sale of Goods
								will not apply to the interpretation or construction of these Terms.
							</p>

							<p>
								Except as otherwise provided herein, these Terms are intended solely for the benefit
								of the parties and are not intended to confer third-party beneficiary rights upon
								any other person or entity.
							</p>
						</div>
					</div>
				</section>
				{/* <!-- end TOS --> */}
			</div>
		</div>
	);
};

export default Tarms;
